export default {
      id: "icon-bubble-usage",
      viewBox: "0 0 41.01 28.384",
      url: __webpack_public_path__ + "icons.svg#icon-bubble",
      toString: function () {
        return this.url;
      }
    }